import { render, staticRenderFns } from "./PreviewForm10.vue?vue&type=template&id=bc1e8d06&scoped=true"
import script from "./PreviewForm10.vue?vue&type=script&lang=ts"
export * from "./PreviewForm10.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e8d06",
  null
  
)

export default component.exports